import React, { useState, useEffect, Fragment } from 'react';
import {
  Row,
  Col,
  Card,
  CardTitle,
  Table
} from 'reactstrap';
import dollar from '../../../assets/images/dollar.png';
import certificate from '../../../assets/images/certi.png';
import user from '../../../assets/images/use.png';
import company from '../../../assets/images/comp.png';
import { ADMIN_DASHBOARD_URL } from '../../../utils/APIEndpoints';
import { authHeader } from '../../../utils/functions/CoreFunctions';
import API from '../../../redux/actions/API';
import {  amountFormat,  dateTimeFormat,  getAlertToast } from '../../../utils/functions/CustomFunctions';
import CustomTableEmptyRecord from '../../common/CustomTableEmptyRecord';
import CustomTableHeader from '../../common/CustomTableHeader';
import CustomTableLoader from '../../common/CustomTableLoader';
import { ADMIN_USERS_PATH, ADMIN_AGENCIES_PATH, ADMIN_REQUESTS_PATH } from '../../../utils/AppRoutes';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';

//Table Columns
const licenseTableColumns = [
  {title:'#'},
  {title:'First Name'},
  {title:'Last Name'},
  {title:'License Name'},
  {title:'Fee'}
];

//Table Columns
const requestTableColumns = [
  {title:'Agency Name'},
  {title:'Document Name'},
  {title:'Hyperlink'},
  {title:'Fee'},
  {title:'Created Date'}
];

const AdminDashboard = (props) => { 
   //State
   const [dashboardData,setDashboardData]  = useState({});
   const [loading,setLoading] = useState(false);
 
   //Get Dashboard Data
   const getDashboardData = async () => {
     try{
       setLoading(true);
       const options = {
           method : 'GET',
           url : ADMIN_DASHBOARD_URL,
           headers: authHeader()
       };
       const response = await API(options);
       const {status} = response.data;
       if(status === 'Success')
       {  
           setDashboardData(response.data);
       }
       }catch(error){
           if (error.response) {
           let { data } = error.response;
           Swal.fire(getAlertToast('error', data.message));
           }
       }finally{
           setLoading(false);
       }
   }
 
    //Did Mount
    useEffect(() => {
      getDashboardData();
    }, []);  

    const {
      totalAdmin = 0,
      totalAgency = 0,
      totalPayment = 0,
      recentRequest = [],
      totalRequest = [],
    } = dashboardData;

    let totalRequests = 0,acceptedCount = 0,pendingCount = 0,rejectedCount = 0 ;
    if(totalRequest.length)
    {
      totalRequests = totalRequest.find(element => element.serviceStatus === 'totalRequest').count;
      acceptedCount = totalRequest.find(element => element.serviceStatus === 'Accepted').count;
      pendingCount = totalRequest.find(element => element.serviceStatus === 'Pending').count;
      rejectedCount = totalRequest.find(element => element.serviceStatus === 'Rejected').count;
    }
   
    return (
        <div >          
          <Row className="mt-4"> 
            <Col xs="3">
              <Link to={ADMIN_USERS_PATH}>
                <Card body>
                  <img src={user} className="dashImg" />
                  <CardTitle className="dashboard-title">Total Admins</CardTitle>
                  <h3 className="mb-2 mt-2 dashboard-value">{totalAdmin}</h3>
                </Card>
              </Link>
            </Col>
            <Col xs="3">
              <Link to={ADMIN_AGENCIES_PATH}>
                <Card body>
                  <img src={company} className="dashImg" />
                  <CardTitle className="dashboard-title">Total Agencies</CardTitle>
                  <h3 className="mb-2 mt-2 dashboard-value">{totalAgency}</h3>
                </Card>
              </Link>
            </Col> 
            <Col xs="3" className="dash-active">
              <Link to={ADMIN_REQUESTS_PATH}>
                <Card body>
                  <img src={certificate} className="dashImg" />
                  <CardTitle className="dashboard-title">Total Requests</CardTitle>
                  <h3 className="mb-2 mt-2 dashboard-value">{totalRequests}</h3>
               
                </Card>
                <Card body className="dash-hover">
                  <p>Accepted : {acceptedCount}</p>
                  <p>Rejected : {rejectedCount}</p>
                  <p>Waiting for approval : {pendingCount}</p>
                  </Card>
              </Link>
            </Col>          
            <Col xs="3">
              <Card body>
                <img src={dollar} className="dashImg" />
                <CardTitle className="dashboard-title">Total Profit</CardTitle>
                <h3 className="mb-2 mt-2 dashboard-value">${parseFloat(totalPayment).toFixed(2)}</h3>
              </Card>
            </Col>
        </Row>
        <Row>
          <Col md="12">
          <Card body className="mt-4">
              <CardTitle className="mb-4 tableTitleBg">Pending Requests For Approval</CardTitle>
                <Table responsive hover>
                  {/* Table Header */}
                   <CustomTableHeader tableColumns={requestTableColumns}/>
                  {/* Table Header */} 
                  <tbody>
                  {loading ? (
                  // Table Loader  
                  <CustomTableLoader columnsCount={requestTableColumns.length}/>
                  // Table Loader  
                  ) : (
                  <Fragment>
                    {!(recentRequest.length) ?
                      //  Empty Record 
                      <CustomTableEmptyRecord columnsCount = {requestTableColumns.length}/>
                      //  Empty Record 
                      :
                      <Fragment>
                    { recentRequest.map((record,key) =>                      
                    <tr key={`record_key_${key}`}>
                    <td>{record.companyName}</td>
                    <td>{record.serviceName}</td>
                    <td><Link target='_blank' to={`/preview-document/${record.serviceDomainURL}`}>{record.serviceDomainURL}</Link></td>
                    <td>{amountFormat(record.serviceAmount)}‎</td>
                    <td>{record.serviceCreatedDate ? dateTimeFormat(record.serviceCreatedDate,'MM/DD/YYYY hh:mm A') : ''}</td>
                    </tr>
                    )}
                    </Fragment>
                  }
                </Fragment>
                 )}
                  </tbody>
                </Table>
              </Card>
          </Col>
          </Row>          
    </div>
  );
}
export default AdminDashboard;
